import { useRef } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ModalPop from "./ModalPop";
import FlowText from "./FlowText";

const Banner = () => {
  const bannerList = [
    {
      img: "/images/banner1.png",
      txt1: "비용이 부담될까봐 걱정이신가요?",
      txt2: `해결하지&nbsp;못한&nbsp;문제는&nbsp;<span className="text-pri">비용&nbsp;ZERO!</span>`,
      txt3: `<span className="text-pri">누수관련 보험서류도 무상 제공!</span>`,
      sub1: "누수문제, 해결하지 못한다면 비용도 받지 않습니다",
      sub2: "누수소견서 및 누수보험에 관련한 자료도 비용 0원!",
    },
    {
      img: "/images/banner2.png",
      txt1: "누수해결 몇번이나 실패하셨었다구요?",
      txt2: `<span className="text-pri">타업체&nbsp;실패현장도&nbsp;해결&nbsp;전문</span>&nbsp;베테랑`,
      txt3: `어떤 현장도 자신있습니다!`,
      sub1: "누수문제, 해결하지 못한다면 비용도 받지 않습니다",
      sub2: "누수소견서 및 누수보험에 관련한 자료도 비용 0원!",
    },
    {
      img: "/images/banner3.png",
      txt1: "누수 문의가 처음이신가요?",
      txt2: `<span className="text-pri">하나부터 열까지 다 </span>알려주니까!`,
      txt3: `<span className="text-pri">안심하고 맡길 수 있는 </span>누수전문가!`,
      sub1: "누수탐지부터 누수공사 + 보험서류 제공 및 기타 공사까지",
      sub2: "어렵게만 생각되던 누수문제 깔끔하게 해결해드립니다.",
    },
    {
      img: "/images/banner1.png",
      txt1: "비용이 부담될까봐 걱정이신가요?",
      txt2: `해결하지&nbsp;못한&nbsp;문제는&nbsp;<span className="text-pri">비용&nbsp;ZERO!</span>`,
      txt3: `<span className="text-pri">누수관련 보험서류도 무상 제공!</span>`,
      sub1: "누수문제, 해결하지 못한다면 비용도 받지 않습니다",
      sub2: "누수소견서 및 누수보험에 관련한 자료도 비용 0원!",
    },
    {
      img: "/images/banner2.png",
      txt1: "누수해결 몇번이나 실패하셨었다구요?",
      txt2: `<span className="text-pri">타업체&nbsp;실패현장도&nbsp;해결&nbsp;전문</span>&nbsp;베테랑`,
      txt3: `어떤 현장도 자신있습니다!`,
      sub1: "누수문제, 해결하지 못한다면 비용도 받지 않습니다",
      sub2: "누수소견서 및 누수보험에 관련한 자료도 비용 0원!",
    },
    {
      img: "/images/banner3.png",
      txt1: "누수 문의가 처음이신가요?",
      txt2: `<span className="text-pri">하나부터 열까지 다 </span>알려주니까!`,
      txt3: `<span className="text-pri">안심하고 맡길 수 있는 </span>누수전문가!`,
      sub1: "누수탐지부터 누수공사 + 보험서류 제공 및 기타 공사까지",
      sub2: "어렵게만 생각되던 누수문제 깔끔하게 해결해드립니다.",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div className="relative w-full h-full">
      <div className=" relative w-full h-full">
        <ModalPop popupRef={popupRef} closefnc={closefunc} />
        <div className="bg-banner relative w-full h-full px-5 lg:px-0 mx-auto items-center max-w-[1400px] mt-24 lg:mt-32 2xl:mt-36">
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              stopOnLastSlide: false,
            }}
            loop={true}
            loopAdditionalSlides={2}
            modules={[Autoplay]}
            className="relative w-full h-full"
          >
            {bannerList.map((v, i) => (
              <SwiperSlide key={`banner-${i}`} className="relative w-full h-full">
                <div className="relative w-full h-full lg:grid grid-cols-2 items-center lg:max-h-[720px]">
                  <div className="relative w-fit lg:ml-auto h-fit">
                    <div className="grid gap-3 mb-5 lg:mb-8">
                      <p className="lg:text-3xl text-black">{v.txt1}</p>
                      <div>
                        <h2
                          className="hidden lg:block gbold text-black"
                          dangerouslySetInnerHTML={{ __html: v.txt2 }}
                        ></h2>
                        <h2
                          className="hidden lg:block gbold text-black"
                          dangerouslySetInnerHTML={{ __html: v.txt3 }}
                        ></h2>
                        <p
                          className="block lg:hidden gbold text-black text-xl"
                          dangerouslySetInnerHTML={{ __html: v.txt2 }}
                        ></p>
                        <p
                          className="block lg:hidden gbold text-black text-xl"
                          dangerouslySetInnerHTML={{ __html: v.txt3 }}
                        ></p>
                      </div>
                      <div>
                        <p className="text-sm lg:text-xl">{v.sub1}</p>
                        <p className="text-sm lg:text-xl">{v.sub2}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <button
                        onClick={() => (window.location.href = "tel:010-9368-5332")}
                        className="outline-none custom-btn btn-11 relative w-fit h-fit text-center rounded-sm px-5 pt-2 pb-1 bg-primary text-white border border-white transition-all duration-300"
                      >
                        <h3 className="glight hidden lg:block">
                          <span className="gbold">무료</span>&nbsp;전화상담
                        </h3>
                        <h5 className="glight block lg:hidden">
                          <span className="gbold">무료</span>&nbsp;전화상담
                        </h5>
                      </button>
                      <button
                        onClick={openfunc}
                        className="outline-none custom-btn btn-11 relative w-fit h-fit text-center rounded-sm px-5 pt-2 pb-1 bg-red text-white border border-white transition-all duration-300"
                      >
                        <h3 className="glight hidden lg:block">
                          <span className="gbold">상세</span>&nbsp;견적문의
                        </h3>
                        <h5 className="glight block lg:hidden">
                          <span className="gbold">상세</span>&nbsp;견적문의
                        </h5>
                      </button>
                    </div>
                  </div>
                  <div className="relative w-full h-full mt-5 lg:mt-0">
                    <img
                      src={v.img}
                      alt="icon"
                      className="!relative w-fit h-fit lg:mr-auto object-contain max-h-80 mx-auto lg:max-h-[720px]"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className=" relative w-full h-fit bg-primary py-5 text-white text-center px-[calc((100%-var(--container))/3)] 3xl:px-[calc((100%-var(--container))/2)] ">
        <p className="font-medium mb-2.5">
          수도권 전지역! <span className="text-point">(서울 · 경기 · 인천)</span> 언제든지&nbsp;문의주시면{" "}
          <span className="text-point">신속히 도착하여 문제를 해결해드립니다.</span>
          &nbsp;(365일 24시간 연중무휴)
        </p>
        <div className="w-full h-[1px]  bg-white opacity-80"></div>
        <FlowText />
      </div>
    </div>
  );
};

export default Banner;
